var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8418 5.69345C12.9204 5.29792 13.0541 4.87956 13.2599 4.51216C13.6167 3.87538 14.1468 3.44578 15 3.44578C15.4142 3.44578 15.75 3.12213 15.75 2.72289C15.75 2.32365 15.4142 2 15 2C13.4532 2 12.4833 2.85554 11.9401 3.82519C11.6061 4.42124 11.418 5.07895 11.3252 5.66495C9.27886 5.97431 7.71429 7.66793 7.71429 9.71084C7.71429 9.95726 7.73705 10.1986 7.78068 10.433C7.92992 11.235 7.76661 12.1206 7.24611 12.7656C6.46476 13.7339 6 14.9476 6 16.2651C6 19.4324 8.68629 22 12 22C15.3137 22 18 19.4324 18 16.2651C18 14.9476 17.5352 13.7339 16.7539 12.7656C16.2334 12.1206 16.0701 11.235 16.2193 10.433C16.263 10.1986 16.2857 9.95726 16.2857 9.71084C16.2857 7.72387 14.8057 6.06732 12.8418 5.69345Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPear);
export default __webpack_public_path__ + "static/media/pear.8c51fc99d823a5a4745c43d534dd6d3a.svg";
export { ForwardRef as ReactComponent };